const mode = import.meta.env.MODE;
let baseurl: string;

if (mode === 'production') {
  baseurl = 'https://askawatch.cbre.com';
  console.log('FetchIncidents: Running in PRODUCTION mode');
} else if (mode === 'staging') {
  baseurl = 'https://askawatch-test.cbre.com';
  console.log('FetchIncidents: Running in non prod mode');
} else {
  baseurl = 'http://localhost:8000';
  console.log('FetchIncidents: Running in DEVELOPMENT mode');
}

export type UserReport = {
  id: number | string;
  type: string;
  storage_url: string;
  configuration_class: string;
  change_number: string | number | null;
  updated_at: string; // ISO/date string from backend
  report_by: string;  // user_email
};

export type AskAWatchChatActivity = {
    timestamps: string;        // ISO/date string
    thread_id: string;
    user_message: string;
    user_email: string;
    example_prompt: string | null;
    prompt_category: string | null;
  };
  
// Helper: convert local "YYYY-MM-DDTHH:mm" to UTC ISO string (no seconds -> :00)
function localInputToUTC(local: string): string {
  // local is from <input type="datetime-local">, interpreted in local tz
  const d = new Date(local);
  if (isNaN(d.getTime())) throw new Error(`Invalid datetime-local: ${local}`);
  return d.toISOString(); // UTC ISO
}

// Fetch activity with optional UTC range (start/end in UTC)
export async function fetchUserActivity(
  opts?: { start?: string; end?: string } // local datetime strings from inputs
): Promise<{ reports: UserReport[] }> {
  const url = new URL(`${baseurl}/api/usermetrics/get_activity`);
  if (opts?.start) url.searchParams.set("start", localInputToUTC(opts.start));
  if (opts?.end) url.searchParams.set("end", localInputToUTC(opts.end));

  const res = await fetch(url.toString(), {
    method: "GET",
    headers: { Accept: "application/json" }
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`fetchUserActivity failed (${res.status}): ${text}`);
  }
  const result = await res.json();
  return result;
}

// Fetch AskAWatch chats with optional UTC range (matches backend if it accepts start/end)
export async function fetchAskAWatchChatsActivity(
  opts?: { start?: string; end?: string } // local datetime strings from inputs
): Promise<{ reports: AskAWatchChatActivity[] }> {
  const url = new URL(`${baseurl}/api/usermetrics/get_askawatch_chats_activity`);
  if (opts?.start) url.searchParams.set("start", localInputToUTC(opts.start));
  if (opts?.end) url.searchParams.set("end", localInputToUTC(opts.end));

  const res = await fetch(url.toString(), {
    method: "GET",
    headers: { Accept: "application/json" }
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`fetchAskAWatchChatsActivity failed (${res.status}): ${text}`);
  }

  const result = await res.json();
  console.log("fetchAskAWatchChatsActivity: Response OK", result);
  return result;
}